import cx from 'classnames'
import {ComponentType, useCallback} from 'react'
import {FoldingProvider, StepCode} from '../../../../providers/FoldingProvider'
import {StepDataProvider} from '../../../../providers/StepDataProvider/StepDataProvider'
import {Title} from './Title'

type Props = {
  title: React.ReactNode
  caption: React.ReactNode
  maximizedComponent: ComponentType
  minimizedComponent: ComponentType
  thisStepCode: StepCode
}

export const Step = ({
  title,
  caption,
  maximizedComponent: MaximizedComponent,
  minimizedComponent: MinimizedComponent,
  thisStepCode,
}: Props) => {
  const activeStepCode = FoldingProvider.useActiveStepCode()
  const setActiveStepCode = FoldingProvider.useActiveStepCodeSetter()
  const thisStepDataManager = StepDataProvider.useStepDataManager(thisStepCode)
  const allowEditing = FoldingProvider.useAllowEditing(thisStepCode)
  const isMaximized = activeStepCode === thisStepCode
  const allowMaximize = !isMaximized && allowEditing

  const edit = useCallback(() => {
    setActiveStepCode(thisStepCode)
  }, [setActiveStepCode, thisStepCode])

  return (
    <div
      className={cx('p-4 flex flex-col gap-4 bg-white rounded-lg', {'cursor-pointer': allowMaximize})}
      onClick={allowMaximize ? edit : undefined}
    >
      {!isMaximized && (
        <div className="flex flex-col">
          <Title title={title} highlighted={isMaximized || thisStepDataManager.isValid('saved')} />
          {thisStepDataManager.isTouched() && (
            <div className={thisStepDataManager.isValid('saved') ? '' : 'text-gray-400'}>
              <MinimizedComponent />
            </div>
          )}
        </div>
      )}
      {isMaximized && (
        <div className="flex flex-col gap-6">
          <div className="font-bold text-xl">{caption}</div>
          <MaximizedComponent />
        </div>
      )}
    </div>
  )
}
